<div id="map" class="map"></div>
<button [class.shift-right]="sidebarIsOpen" id="resetViewButton" (click)="resetView()" style="display:none">
    {{ 'MAP.RESET' | translate }} <fa-icon [icon]="faCross"></fa-icon>
</button>
<ng-template #iconTemplate let-item>
    <div class="icon-overlay" [ngStyle]="{'border-color': item.capteur.borderColor}">
    <i *ngIf="item.capteur.type != 'hydrometrie' && item.capteur.type != 'pluviometres'" [class]="item.capteur.icon" 
    [ngClass]="item.capteur.dataType === 'Source' ? 'icon-symbol-square' : 'icon-symbol-circle'" 
     [style]="{'color': item.capteur.textColor, 'font-size': item.capteur.fontSize, 'background-color': item.capteur.backgroundColor, 'border': item.capteur.border, 'cursor': item.capteur.cursor , 'padding': item.capteur.padding }"
        ></i>
    <fa-icon *ngIf="item.capteur.type === 'hydrometrie' || item.capteur.type === 'pluviometres'" [icon]="item.capteur.icon" [styles]="{'color': item.capteur.textColor, 'font-size': item.capteur.fontSize, 'background-color': item.capteur.backgroundColor, 'border': item.capteur.border, 'cursor': item.capteur.cursor,  'padding': item.capteur.padding, 'transform': item.capteur.transform }"></fa-icon>
    </div>
    
</ng-template>

<div #iconsContainer></div>
<div *ngIf="isLoadingSensors || isLoadingBsn" [class.shift-right]="sidebarIsOpen" class="loading-content">
    <fa-icon [icon]="faSpinner"></fa-icon>
    <div>{{ 'MAP.LOADING_SENSOR' | translate }}</div>
</div>
<app-model-headband [ipsData]="ipsDataOfSelectedSensor" [hasModel]="hasModalForHeadband"></app-model-headband>

